import { Component, OnInit, ViewChild } from '@angular/core';
import { CookiesModalComponent } from 'src/app/shared/cookies-modal/cookies-modal.component';
import { ModalConfig } from "src/app/shared/cookies-modal/cookies-modal.config";

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.css']
})
export class CookiesComponent implements OnInit {

  @ViewChild('modal') private modal?: CookiesModalComponent

  public modalConfig: ModalConfig = {
    modalTitle: "Title",
    onDismiss: () => {
      return true
    },
    dismissButtonLabel: "Dismiss",
    onClose: () => {
      return true
    },
    closeButtonLabel: "Close"
  }



  constructor() { }

  async openModal() {
    return await this.modal?.open()
  }

  ngOnInit(): void {
  }

}
